/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React, { Component } from "react";
import { ClassicPDFPageContainer } from "containers/document/page/ClassicPDFPageContainer";
import SinglePageViewCss from "./SinglePageView.css";
import * as stores from "stores";
import { getCurrentPageIndex } from "selectors/pageNumber";

class SinglePageView extends Component {
  constructor(props) {
    super(props);
  }

  componentDidUpdate() {
    const currPageIndex = getCurrentPageIndex(stores);
    if (currPageIndex === this.props.pageIndex) {
      // component update is happening due to zoom in current page.
      this.elementHandle.scrollLeft = this.props.pagesViewXPos;
      this.elementHandle.scrollTop = this.props.pagesViewYPos;
    }
  }

  render() {
    let style;
    if (this.props.isFullScreenMode || this.props.isFitOneFullPageMode) {
      style = {
        position: "sticky",
        top: this.props.fitPageTopPosition,
        height: this.props.fitPageViewHeight,
        width: "100%"
      };

      if (this.props.isFitOneFullPageMode) {
        style.overflow = "hidden";
      }
    }

    return (
      <div
        className={SinglePageViewCss.SinglePageView}
        style={style}
        ref={handle => {
          this.elementHandle = handle;
        }}
      >
        <ClassicPDFPageContainer pageIndex={this.props.pageIndex} key={this.props.pageIndex} useSinglePageCSS />
      </div>
    );
  }
}

export { SinglePageView };
